
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/engine.io-client/index.js
// module id = ./node_modules/engine.io-client/index.js
// module chunks = vendor